// Module-scoped frozen copy — values live here after sealEnv(), not on window.
let _env = null;

const _resolve = () => {
  if (!_env) _env = Object.freeze(Object.assign({}, window._env_ || {}));
  return _env;
};

export const getEnv = (key) => _resolve()[key];

/**
 * Called once in index.js before the app renders.
 *
 * 1. Copies window._env_ into a frozen module-scoped object.
 * 2. Deletes window._env_ from the global.
 * 3. Redefines window._env_ as a non-enumerable, non-configurable property
 *    whose getter always returns undefined and whose setter is a no-op.
 *
 * Result in browser console:
 *   window._env_              → undefined
 *   window._env_ = { x: 1 }  → silently ignored
 *   Object.keys(window)       → '_env_' not listed
 */
export const sealEnv = () => {
  _env = Object.freeze(Object.assign({}, window._env_ || {}));

  try { delete window._env_; } catch (e) { /* non-configurable — handled below */ }

  try {
    Object.defineProperty(window, '_env_', {
      get: () => undefined,
      set: () => {},        // silently swallow any assignment attempt
      enumerable: false,    // hidden from Object.keys(window)
      configurable: false,  // cannot be redefined or deleted
    });
  } catch (e) { /* already locked */ }
};
